export const Durations = {
	sliderDuration: 1000,
	flipSliderDuration: 600,
	colorTransitionDuration: '300ms',
};

export const clickZonePercentage = 0.33;
